// Extension de tipos
import './string-prototypes';

// Angular
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Http, HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { TranslateModule, TranslateLoader, TranslateStaticLoader  } from 'ng2-translate';
import {AccordionModule} from 'primeng/accordion';
import 'rxjs/add/operator/toPromise';

// import Canvg from 'canvg';

// PrimeNG Modules
import {
	DialogModule,
	DropdownModule,
	GrowlModule,
	MessagesModule,
	ScrollPanelModule,
	SlideMenuModule,
	ConfirmDialogModule,
	InputMaskModule,
	InputSwitchModule,
	InputTextModule,
	InputTextareaModule,
	SpinnerModule,
	FileUploadModule
} from 'primeng/primeng';

import { ProgressSpinnerModule } from 'primeng/progressspinner';

// APP-COMPONENTS
import { AppComponent } from './app.component';
import { AppMenuComponent, AppSubMenuComponent } from './app.menu.component';
import { AppBreadcrumbComponent } from './app.breadcrumb.component';
import { AppTopBarComponent } from './app.topbar.component';
import { AppFooterComponent } from './app.footer.component';

import { AppRoutes } from './app.routes';

// Modulos
import { ContenidosModule } from './modules/contenidos.module';
import { DashboardModule } from './modules/dashboard.module';
import { EntidadesModule } from './modules/entidades.module';
import { MapasModule } from './modules/mapas.module';
import { MensajesModule } from './modules/mensajes.module';
import { NoticiasModule } from './modules/noticias.module';
import { RutasSugeridasModule } from './modules/rutas.sugeridas.module';
import { SelectorEspacioModule } from './modules/selector.espacio.module';
import { BalizasModule } from './modules/balizas.module';
import { InformesModule } from './modules/informes.module';
import { EncuestasModule } from './modules/encuestas.module';
// Componentes
import { LoginComponent } from './views/Login/Login.component';
import { BreezeTestComponent } from './views/BreezeTest/BreezeTest.component';
import { DescargaAppComponent } from './views/DescargaApp/DescargaApp.component';
// Servicios
import { EntityManagerProvider } from './providers/entity-manager-provider/entity-manager-provider';
import { ServiciosWebServiceProvider } from './providers/web-service-service/servicios-web-service';
import { ServiciosStatsProvider } from './providers/web-service-service/servicios-stats';
import { IdiomaService } from './providers/idioma/idioma.service';
import { DiagnosticoService } from './providers/diagnostico/diagnostico.service';
import { PermisosService } from	'./providers/authentication/permisos.service';
import { InformesService } from './providers/informes/informes.service'

import { BreezeBridgeAngularModule } from 'breeze-bridge-angular';
import { BreadcrumbService } from './breadcrumb.service';

import { JwtModule } from '@auth0/angular-jwt';
import { AuthenticationService } from './providers/authentication/authentication.service';
import { RoleGuardService } from './providers/authentication/role-guard.service';
import { ReactiveFormsModule } from '@angular/forms';

// ALASQL
import 'rxjs/add/operator/toPromise';
import * as alasql from 'alasql';


export function getToken() {
	return localStorage.getItem('token');
}
export function getEntidad() {
	return localStorage.getItem('Entidad');
}
@NgModule({
	exports: [
		TranslateModule
	],
	imports: [
		// ComponentesModule,
		ContenidosModule.forRoot(),
		DashboardModule.forRoot(),
		EntidadesModule.forRoot(),
		BalizasModule.forRoot(),
		MapasModule,
		MensajesModule.forRoot(),
		NoticiasModule.forRoot(),
		RutasSugeridasModule.forRoot(),
		SelectorEspacioModule.forRoot(),
		InformesModule.forRoot(),
		EncuestasModule.forRoot(),
		AppRoutes,

		BreezeBridgeAngularModule,
		BrowserModule,
		ConfirmDialogModule,
		DropdownModule,
		FormsModule,
		HttpClientModule,
		HttpModule,
		InputMaskModule,
		InputSwitchModule,
		InputTextModule,
		InputTextareaModule,
		ReactiveFormsModule,
		FileUploadModule,

		ProgressSpinnerModule,
		SpinnerModule,

		BrowserAnimationsModule,
		AccordionModule,
		DialogModule,
		GrowlModule,
		MessagesModule,
		ScrollPanelModule,
		SlideMenuModule,
		JwtModule.forRoot({
			config: {
				tokenGetter: getToken
			}
		}),
		TranslateModule.forRoot({
            provide: TranslateLoader,
            useFactory: function(http: Http){ return new TranslateStaticLoader(http, '/assets/i18n', '.json'); },
            deps: [Http]
		})


	],
	declarations: [
		AppComponent,
		AppMenuComponent,
		AppSubMenuComponent,
		AppBreadcrumbComponent,
		AppTopBarComponent,
		AppFooterComponent,
		BreezeTestComponent,
		LoginComponent,
		DescargaAppComponent
	],
	providers: [
		AppComponent,
		{
			provide: LocationStrategy,
			useClass:
				HashLocationStrategy
		},
		BreadcrumbService,
		ServiciosWebServiceProvider,
		ServiciosStatsProvider,
		EntityManagerProvider,
		DiagnosticoService,
		IdiomaService,
		AuthenticationService,
		RoleGuardService,
		PermisosService,
		InformesService
	],
	bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/app.module.ts